import * as React from "react";
import { SVGProps } from "react";
export const SparkleIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.9219 6.66666L16.5802 5.20833L18.0385 4.55C18.3635 4.4 18.3635 3.94166 18.0385 3.79166L16.5802 3.13333L15.9219 1.66666C15.7719 1.34166 15.3135 1.34166 15.1635 1.66666L14.5052 3.125L13.0385 3.78333C12.7135 3.93333 12.7135 4.39166 13.0385 4.54166L14.4969 5.2L15.1552 6.66666C15.3052 6.99166 15.7719 6.99166 15.9219 6.66666ZM9.28855 7.91666L7.96355 5C7.67188 4.35 6.73855 4.35 6.44688 5L5.12188 7.91666L2.20521 9.24166C1.55521 9.54166 1.55521 10.4667 2.20521 10.7583L5.12188 12.0833L6.44688 15C6.74688 15.65 7.67188 15.65 7.96355 15L9.28855 12.0833L12.2052 10.7583C12.8552 10.4583 12.8552 9.53333 12.2052 9.24166L9.28855 7.91666ZM15.1552 13.3333L14.4969 14.7917L13.0385 15.45C12.7135 15.6 12.7135 16.0583 13.0385 16.2083L14.4969 16.8667L15.1552 18.3333C15.3052 18.6583 15.7635 18.6583 15.9135 18.3333L16.5719 16.875L18.0385 16.2167C18.3635 16.0667 18.3635 15.6083 18.0385 15.4583L16.5802 14.8L15.9219 13.3333C15.7719 13.0083 15.3052 13.0083 15.1552 13.3333Z"
            fill="currentColor"
        />
    </svg>
);
SparkleIcon.displayName = "SparkleIcon";
